import "./style.scss";

function ConfirmationModal({
  id,
  setConfirmationModal,
  onConfirm,
  showInput = false,
  inputValue = "",
  setInputValue,
}) {
  return (
    <div className="confirmationModal_wrapper">
      <h2>Are you sure?</h2>
      {showInput && (
        <input
          type="number"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className="input_container"

          placeholder="Enter your Amount..."
        />
      )}
      <div className="buttons_wrapper">
        <button
          className="confirm"
          onClick={() => {
            onConfirm(id);
            setConfirmationModal(false);
          }}
        >
          Confirm
        </button>
        <button className="cancel" onClick={() => setConfirmationModal(false)}>
          Cancel
        </button>
      </div>
    </div>
  );
}
export default ConfirmationModal;
